export default __webpack_public_path__ + "static/media/orderreport.68869c31.svg";